// extracted by mini-css-extract-plugin
export default {"cartItemContainer":"Cart_cartItemContainer__4vN1X","cartImg":"Cart_cartImg__rvbYv"};